import { FeatureSection } from "./AccountFeature";

export const AddOnSection = ({ addons, toggleAddon }) => {
  const availableAddons = [
    {
      name: "AI Growth Insights",
      desc: "Generate actionable growth insights from your data",
      price: "£20/mo",
      logo: "/logos/ai-insights.png",
      status: "included",
      category: "analytics",
    },
    {
      name: "Custom Reports",
      desc: "Create branded PDF/Excel reports",
      price: "£15/mo",
      logo: "/logos/reports.png",
      status: "coming",
      comingSoonDate: "Nov 2025",
      category: "analytics",
    },
    {
      name: "Email Alerts",
      desc: "Get notified about anomalies or trends",
      price: "£10/mo",
      logo: "/logos/email-alerts.png",
      status: "coming",
      comingSoonDate: "Dec 2025",
      category: "notifications",
    },
    {
      name: "Custom Dashboards",
      desc: "Build your own dashboards with selected metrics",
      price: "£15/mo",
      logo: "/logos/dashboard.png",
      category: "dashboard",
    },
    {
      name: "Multi-user Access",
      desc: "Add team members with custom permissions",
      price: "£20/mo",
      logo: "/logos/team.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "collaboration",
    },
    {
      name: "Data Export",
      desc: "Export raw or processed data to CSV/JSON",
      price: "£10/mo",
      logo: "/logos/export.png",
      category: "analytics",
    },
    {
      name: "Scheduled Reports",
      desc: "Automatically send reports to stakeholders",
      price: "£15/mo",
      logo: "/logos/scheduled-reports.png",
      status: "coming",
      comingSoonDate: "Dec 2025",
      category: "analytics",
    },
    {
      name: "Third-party Integrations",
      desc: "Connect external apps like Slack or Zapier",
      price: "£20/mo",
      logo: "/logos/integrations.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "integration",
    },
    {
      name: "Anomaly Detection",
      desc: "Highlight unusual trends in your metrics",
      price: "£15/mo",
      logo: "/logos/anomaly.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "analytics",
    },
    {
      name: "KPI Alerts",
      desc: "Receive alerts when KPIs exceed thresholds",
      price: "£10/mo",
      logo: "/logos/kpi.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "notifications",
    },
    {
      name: "Benchmarking",
      desc: "Compare metrics against industry standards",
      price: "£15/mo",
      logo: "/logos/benchmark.png",
      status: "coming",
      comingSoonDate: "Mar 2026",
      category: "analytics",
    },
    {
      name: "AI Recommendations",
      desc: "Receive automated growth recommendations",
      price: "£20/mo",
      logo: "/logos/ai-recommendations.png",
      status: "coming",
      comingSoonDate: "Mar 2026",
      category: "analytics",
    },
    {
      name: "Theme Customization",
      desc: "Apply your brand colors & logo in the dashboard",
      price: "£10/mo",
      logo: "/logos/theme.png",
      category: "dashboard",
    },
    {
      name: "Export Visualizations",
      desc: "Download charts & graphs as images or PDFs",
      price: "£10/mo",
      logo: "/logos/charts.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "analytics",
    },
    {
      name: "Custom Notifications",
      desc: "Trigger custom alerts for any metric",
      price: "£10/mo",
      logo: "/logos/notifications.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "notifications",
    },
    {
      name: "Multi-language Support",
      desc: "Switch dashboard language dynamically",
      price: "£10/mo",
      logo: "/logos/language.png",
      status: "coming",
      comingSoonDate: "May 2026",
      category: "dashboard",
    },
  ];

  return (
    <FeatureSection
      title="Available Bolt-ons"
      items={availableAddons}
      selectedItems={addons}
      toggleItem={toggleAddon}
    />
  );
};
